export default __webpack_public_path__ + "static/home-elizabeth-914476579d1a941c202ad630f570bd2d.jpg";